import React from 'react';
import { Col, Row } from 'react-bootstrap';
import Button from '../button';
import { useNamespacedTranslation } from '../../hooks/useNamespacedTranslation';
import styled from '@emotion/styled';
import { formatPeriodBounds, Period } from './formatPeriod';

export type Props = {
  periods: Period[];
  selectedIndex: number;
  onPeriodChanged: (index: number) => void;
};

const PeriodNav: React.FC<React.PropsWithChildren<Props>> = ({
  periods,
  selectedIndex,
  onPeriodChanged,
}) => {
  const t = useNamespacedTranslation('periodNav');

  const selected = periods[selectedIndex];
  if (!selected) {
    return null;
  }

  return (
    <Row className="justify-content-between align-items-center">
      <StyledCol className="col-auto">
        {selectedIndex > 0 && (
          <Button
            className="h7-medium"
            label={t('previousPeriod')}
            variant="link"
            onClick={() => onPeriodChanged(selectedIndex - 1)}
          />
        )}
      </StyledCol>
      <Col className="col-auto">
        <div className="text-center h7-medium">
          {t('message', formatPeriodBounds(selected))}
        </div>
      </Col>
      <StyledCol className="col-auto">
        {selectedIndex < periods.length - 1 && (
          <Button
            className="h7-medium"
            label={t('nextPeriod')}
            variant="link"
            onClick={() => onPeriodChanged(selectedIndex + 1)}
          />
        )}
      </StyledCol>
    </Row>
  );
};

const StyledCol = styled(Col)`
  min-width: 9rem;
`;

export default PeriodNav;
